import React, {memo} from "react";
import { commonStyle } from "../styles";
import {
    Icon,
    HStack, 
    Avatar, 
    Heading, 
    VStack, 
    Box, 
    Center,
    Stack,
    Badge,
    Input,
    Image,
    IconButton,
    Pressable,
    Divider,
    HamburgerIcon,
    Progress,
    Menu,
    Text, 
    Flex } from 'native-base';
  import {MdRemoveRedEye, MdModeEdit, MdHistory, MdMoreVert, MdDelete, MdDownload, MdDriveFileMove, MdFactCheck } from 'react-icons/md';
  import {FaCalendarAlt, FaEnvelope, FaAngleDown, FaCalendarTimes, FaCalendarCheck, FaWrench, FaTruck } from 'react-icons/fa';
  import moment from "moment";
  import BadgeStatus from "./BadgeStatus";
  import helper from "../util/helper";
  import history from "../util/history";

const CardWasteAcceptanceList = (props) => {
  const {data, access, onDelete} = props;
  return (
    <Box width="100%" backgroundColor={commonStyle.baseColor} shadow={3} borderRadius="lg">
      <VStack>
        <Box px={5} py={3} backgroundColor={commonStyle.cardBaseHeaderBg} borderTopRadius="lg">
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Box>
              <Icon color="darkText" as={<Box><FaCalendarAlt/></Box>} size={5}></Icon>
            </Box>
            <Box flex={1} ml={1}>
              <Text color="darkText" fontWeight={500} >
                {moment(data.tgl_transfer, "YYYY-MM-DD HH:mm:ss").format("DD MMM YYYY HH:mm")}
              </Text>
            </Box>
            <Box ml={3}>
              <BadgeStatus status={data.nama_stat} />
            </Box>
            <Box ml={2} alignItems="center" justifyContent="center" width={8} height={8}>
              <Menu mt={2} py={2} placement="bottom right" trigger={triggerProps => {
                return <Pressable accessibilityLabel="More options menu" {...triggerProps}>
                        <Icon as={<Box><MdMoreVert/></Box>} size={8} color="gray.600" />
                      </Pressable>;
              }}>
                {access.includes('6:VIEW') && 
                <Menu.Item p={1} onPress={() => history.push('waste-accept-form', {viewOnly: true, id_transfer: data.id_transfer, id_penerimaan: data.id_penerimaan_limbah})}>
                  <HStack space={2} justifyContent="center" alignItems="center">
                    <Icon as={<Box><MdRemoveRedEye/></Box>} size="md" color="info.700" />
                    <Text color="darkText" fontSize="md">
                      View
                    </Text>
                  </HStack>
                </Menu.Item>
                }
                {(access.includes('6:EDIT') && data.code_status != '30') && 
                <Menu.Item p={1} onPress={() => history.push('waste-accept-form', {viewOnly: false, id_transfer: data.id_transfer, id_penerimaan: data.id_penerimaan_limbah})}>
                  <HStack space={2} justifyContent="center" alignItems="center">
                    <Icon as={<Box><MdDriveFileMove/></Box>} size="md" color="info.700" />
                    <Text color="darkText" fontSize="md">
                      Proses Transfer
                    </Text>
                  </HStack>
                </Menu.Item>
                }
                {(access.includes('6:DEL')) && 
                <Menu.Item p={1} onPress={() => onDelete(data.id_penerimaan_limbah)}>
                  <HStack space={2} justifyContent="center" alignItems="center">
                    <Icon as={<Box><MdDelete/></Box>} size="md" color="info.700" />
                    <Text color="darkText" fontSize="md">
                      Hapus Permintaan
                    </Text>
                  </HStack>
                </Menu.Item>
                }
              </Menu>
            </Box>
          </Stack>
        </Box>
        <Box p={5}>
          <VStack>
            <Flex flexDirection="row" mb={3} alignItems="center">
              <Box width={8} height={8} borderRadius="lg" backgroundColor="primary.400" justifyContent="center">
                <Center>
                  <Icon color="white" as={<Box><FaEnvelope/></Box>} size={5}></Icon>
                </Center>
              </Box>
              <Box ml={2}>
                <Text color="darkText">
                  {data.code_transfer}
                </Text>
              </Box>
            </Flex>
            <Flex flexDirection="row" mb={3} alignItems="center">
              <Box width={8} height={8} borderRadius="lg" backgroundColor="primary.400" justifyContent="center">
                <Center>
                  <Icon color="white" as={<Box><MdFactCheck/></Box>} size={5}></Icon>
                </Center>
              </Box>
              <Box ml={2}>
                <Text color="darkText">
                  {data.code_penerimaan}
                </Text>
              </Box>
            </Flex>
            <HStack flex={1} mb={3} space={2}>
              <Box flex={1}>
                <VStack>
                  <Text color="darkText" bold>Tgl Permintaan</Text>
                  <Text color="darkText">
                    {data.tgl_penerimaan ? moment(data.tgl_penerimaan, "YYYY-MM-DD HH:mm:ss").format("DD MMM YYYY HH:mm") : '-'}
                  </Text>
                </VStack>
              </Box>
              <Box flex={1}>
                <VStack>
                  <Text color="darkText" bold>Unit / Fakultas</Text>
                  <Text color="darkText">
                    {data.nm_unit_asal}
                  </Text>
                </VStack>
              </Box>
            </HStack>
            <Box flex={1} mb={3}>
              <VStack>
                <Text color="darkText" bold>Catatan</Text>
                <Text color="darkText">
                  {data.noted}
                </Text>
              </VStack>
            </Box>
            <Flex flexDirection="row" mb={3}>
              <Box>
                <Center>
                  <Avatar size="md" bg="primary.900" mr="1">
                      {helper.getInitials(data.nm_vendor)}
                  </Avatar>
                </Center>
              </Box>
              <VStack width="90%">
                <Text ml={3} fontSize="lg" color={commonStyle.primaryColor} isTruncated width="80%" fontWeight="bold">
                  {data.nm_pengirim}
                </Text>
                <Text ml={3} fontSize="sm" color="muted.500" isTruncated width="80%">
                  {data.hp_pengirim}
                </Text>
              </VStack>
            </Flex>
            
          </VStack>
        </Box>
      </VStack>
  </Box>
  );
}

export default memo(CardWasteAcceptanceList);